module.exports = __webpack_public_path__ + "public/images/slider/speaker-7-icon.fc3566a1a0762485e4bfa727630babdc.jpg";